export interface DayQty {
  period_date: string;
  quantity: number;
  manual?: boolean;
}

// Spread what's left of the month target evenly over the fillable dates,
// keeping every other day's quantity as-is: past days, promo days, and cells
// the user typed by hand (manual). Integer quantities: floor(remaining / n)
// per day, remainder goes +1 to the earliest days, so the filled sum matches
// remaining exactly. Overshoot (kept > target) fills zeros — the Sum vs Target
// column surfaces the overage.
export function distributeRemaining(
  monthTarget: number,
  dayCells: DayQty[],
  fillDates: string[],
): DayQty[] {
  const manualDates = new Set(
    dayCells.filter((c) => c.manual).map((c) => c.period_date),
  );
  const fillable = fillDates.filter((d) => !manualDates.has(d));
  if (fillable.length === 0) return [];

  const fill = new Set(fillable);
  const kept = dayCells.reduce(
    (s, c) => s + (fill.has(c.period_date) ? 0 : c.quantity || 0),
    0,
  );
  const remaining = Math.max(0, monthTarget - kept);
  const base = Math.floor(remaining / fillable.length);
  const extra = remaining % fillable.length;
  return [...fillable]
    .sort()
    .map((d, i) => ({ period_date: d, quantity: base + (i < extra ? 1 : 0), manual: false }));
}
